export default {"src":"/_next/static/media/BRKR.367352ef.svg","height":18,"width":18};